import { IUser } from "../schemas/entity_set"
import { IAuthService } from "../authentication/auth_service"
import { MessageBox, Toast } from "../helpers/message_box"
import { Routes, SignalEvents } from '../helpers/config_keys';

interface IMenuItem {
    label: string;
    route: string;
    icon: string;
    privilege: string;
}

interface ISignalNotice {
    signalEvent: string
    message: string
    success: boolean
}

const SignalHub = "notify";

class MainCtrl {
    version: string;
    username: string;
    menuItems: Array<IMenuItem>

    static $inject = ["$q", "$rootScope", "$state", "AuthService", "ProcessStream"];

    constructor(private $q: angular.IQService,
        private $rootScope: any,
        private $state: angular.ui.IStateService,
        private authenticate: IAuthService,
        private processStream: any) {
        this.setVersion()
        this.setUserName()
        this.setUserMenus()
        this.$rootScope.$state = this.$state;
        this.eventListerners()
    }

    isLoggedIn() {
        this.setUserName()
        return this.authenticate.isLogin();
    }

    signOut() {
        this.authenticate.logOut().then((res) => {
            if (res.success) {
                this.$state.go(Routes.Login)
            }
        })
    }

    setVersion() {
        this.version = "1.0"
    }

    setUserName() {
        let user = this.authenticate.currentUser
        this.username = user ? user.name : ""
    }

    isAuthorize(privilege: string) {
        return this.authenticate.isAuthorize(privilege)
    }

    setUserMenus() {
        let menus: Array<IMenuItem> = [
            { label: "Dashboard", route: Routes.Dashboard, icon: "fa fa-dashboard", privilege: "Dashboard" },
            { label: "Membership", route: Routes.Members, icon: "fa fa-address-card-o", privilege: "Member.Read" },
            { label: "Transactions", route: Routes.Transactions, icon: "fa fa-list-alt", privilege: "Transaction.Read" },
            { label: "Investments", route: Routes.Investments, icon: "fa fa-line-chart", privilege: "Investment.Read" },
            { label: "Reports", route: Routes.Reports, icon: "fa fa-bar-chart-o", privilege: "Report" },
            // { label: "Settings", route: Routes.Settings, icon: "fa fa-cogs" },
            { label: "Manage Users", route: Routes.Users, icon: "fa fa-users", privilege: "Administration" },
        ]

        this.menuItems = menus;
    }

    private eventListerners() {
        this.processStream.on(SignalHub, (signal: ISignalNotice) => {

            switch (signal.signalEvent) {
                case SignalEvents.InterestProcess:
                    // Toast.display(signal.message, signal.success)
                    let stateName = this.$state.current.name;
                    if (stateName == Routes.Investments || stateName == Routes.Investment) {
                        this.$state.reload();
                    }
                    break;
                default:
                    break;
            }
        })
    }

}

export { MainCtrl }


// WEBPACK FOOTER //
// ./app/main/main_ctrl.ts